import starWorker from "../../Assets/Images/star-worker.webp";
import squareBuilding from "../../Assets/Images/square-fine-building.webp";
import circleCement from "../../Assets/Images/circle-cement.webp";
import halfZinc from "../../Assets/Images/half-circle-zinc.webp";
import halfCircleLady from "../../Assets/Images/ladyPolygon.webp";
// import halfCircleLady from '../../Assets/Images/lady-svg.svg'
// import halfCircleLady from '../../Assets/Images/ladyPolygon2.svg'
// import halfCircleLady from '../../Assets/Images/Vector (2).png';

const images = [
  {
    src: starWorker,
    alt: "worker",
  },
  {
    src: squareBuilding,
    alt: "building",
  },
  {
    src: circleCement,
    alt: "cement",
  },
  {
    src: halfCircleLady,
    alt: "lady",
  },
  {
    src: halfZinc,
    alt: "zinc",
  },
  {
    src: squareBuilding,
    alt: "building",
  },
];

export default images;
